import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row text-center" }
const _hoisted_2 = { class: "flex items-center justify-center" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_4 = {
  key: 1,
  class: "flex items-center justify-center"
}

import { computed} from "vue";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import DialogComponent from "@/components/doalog/DialogComponent.vue";
import QrcodeVue from 'qrcode.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'QrCodeManualDepositDialog',
  props: {
  qrCodeText: String,
  amount: String,
  expiredAt: String,
  open: Boolean,
},
  emits: [
  "update:open",
  "update:qrCodeText",
],
  setup(__props, { emit }) {

const props = __props

dayjs.extend(localizedFormat);





const qrCodeSync = computed({
  get: () => props.qrCodeText,
  set: (value) => emit("update:qrCodeText", value),
});
const amountSync = computed({
  get: () => props.amount,
  set: (value) => emit("update:amount", value),
});
const expiredAtSync = computed({
  get: () => props.expiredAt,
  set: (value) => emit("update:expiredAt", value),
});
const openSync = computed({
  get: () => props.open,
  set: (value) => {
    emit("update:open", value)
  },
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogComponent, {
    isOpen: _unref(openSync),
    title: `Qrcode Manual Payment Deposit`
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(QrcodeVue, {
            value: _unref(qrCodeSync),
            size: "300"
          }, null, 8, ["value"])
        ]),
        (_unref(amountSync))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("label", null, "Amount: " + _toDisplayString(_unref(amountSync)), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(expiredAtSync))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("label", null, "Expired At: " + _toDisplayString(_unref(expiredAtSync)), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openSync.value = false)),
          class: "m-1 p-2 bg-red-500 rounded text-white"
        }, _toDisplayString(_ctx.$t(`messages.player.id.cancel`)), 1)
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}
}

})